var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5125 15.6499L7.525 4.64988C7.37358 4.55647 7.19998 4.50516 7.02211 4.50122C6.84424 4.49729 6.66854 4.54088 6.51314 4.6275C6.35774 4.71411 6.22826 4.84062 6.13805 4.99397C6.04785 5.14732 6.0002 5.32196 6 5.49988V27.4999C6.0002 27.6778 6.04785 27.8524 6.13805 28.0058C6.22826 28.1591 6.35774 28.2856 6.51314 28.3723C6.66854 28.4589 6.84424 28.5025 7.02211 28.4985C7.19998 28.4946 7.37358 28.4433 7.525 28.3499L25.5125 17.3499C25.6602 17.2625 25.7826 17.1382 25.8676 16.9892C25.9526 16.8401 25.9974 16.6715 25.9974 16.4999C25.9974 16.3283 25.9526 16.1596 25.8676 16.0106C25.7826 15.8615 25.6602 15.7372 25.5125 15.6499V15.6499Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.509d1cae116876effa32866b457ed09f.svg";
export { ForwardRef as ReactComponent };